import { CreateCamiseta } from "interfaces/kitsCamiseta";
import formFieldCamiseta from "./formFieldKits";

const { id, tamanho, quantidade, eventId } = formFieldCamiseta;

const initialValuesCamiseta = (eventoId: number) => {
  return {
    [tamanho.name]: "",
    [quantidade.name]: 100,
    [eventId.name]: eventoId,
  };
};

const initialValuesEditCamiseta = (kits: CreateCamiseta) => {
  return {
    [id.name]: kits.id,
    [tamanho.name]: kits.tamanho,
    [quantidade.name]: kits.quantidade,
    [eventId.name]: kits?.eventId || "",
  };
};

export { initialValuesCamiseta, initialValuesEditCamiseta };
